const initialState = {
  all: [],
  modal: {
    open: false,
    id: null,
  }
};

export default function permissionReducer(state = initialState, action) {
  switch (action.type) {
    case 'PERMISSION_GET_ALL_REQUEST':
      return {
        ...state,
        all: action.payload
      };
    case 'PERMISSION_OPEN_MODAL':
      return {
        ...state,
        modal: {
          ...state.modal,
          open: action.payload
        }
      };
     case 'PERMISSION_UPDATE_VALUE':
      let copy = [...state.all];
      const index = copy.findIndex(item => item.id === action.payload.id);
      const newArray = [...state.all];
      newArray[index].read = action.payload.read;
      return {
        ...state,
        ...state.all,
        all: newArray
      }; 
    default:
      return state
  }
}